import React, { useEffect } from "react";
import { Modal, Form, Input, InputNumber, message } from "antd";
import api from "../api";

const EditIngresoGranelModal = ({ open, record, onCancel, onSuccess }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open && record) {
      form.setFieldsValue({
        taraIndividual: record.taraIndividual,
        procesadas: record.procesadas,
        pesoBrutoTotal: record.pesoBrutoTotal,
        observaciones: record.observaciones,
      });
    } else {
      form.resetFields();
    }
  }, [open, record, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      await api.put(`/ingresosGranel/modificar/${record.idingresos}`, values);
      message.success("Ingreso modificado exitosamente");
      form.resetFields();
      onSuccess();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        message.error(error.response.data.message);
      } else {
        message.error("Error al modificar el ingreso granel");
      }
    }
  };

  return (
    <Modal
      title="Editar Ingreso a Granel"
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      okText="Guardar"
      cancelText="Cancelar"
    >
      <Form form={form} layout="vertical">
        <Form.Item name="taraIndividual" label="Tara Individual (kg)" rules={[{ required: true }]}>
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item name="procesadas" label="Procesadas" rules={[{ required: true }]}>
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item name="pesoBrutoTotal" label="Peso Bruto Total (kg)" rules={[{ required: true }]}>
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item name="observaciones" label="Observaciones">
          <Input.TextArea />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditIngresoGranelModal;
